module.exports = __webpack_public_path__ + "img/2025-09-19d_2.b3e7c9ec.jpg";